export default __webpack_public_path__ + "static/media/solicitudReembolso.9e0ab7f4.svg";